import { MappingType } from 'new/elements/flows/Databases/useDatabases';

export const getMapping = (mapping: MappingType) => {
  if (!mapping) return null;
  return Object.keys(mapping).reduce((map, tableName) => {
    map[tableName] = {
      columns: mapping[tableName],
    };
    return map;
  }, {});
};
